<template>
  <section class="section">
    <div class="container is-mobile">
    	<h1 class="title">Create</h1>
    	<p class="subtitle">Generate Printable PDF File</p>

    	<div class="field">
    		<label class="label">Conditioning Phase</label>
    		<div class="select">
				  <select disabled>
            <option>Max Strength</option>
				  </select>
				</div>
    	</div>
    	<label class="label">Gymnasts</label>
    	<div class="field">
    		<label class="checkbox">
				  <input type="checkbox" checked v-model="allGymnasts">
				  All Current Gymnasts
				</label>
    	</div>
    	<div class="field">
    		<div class="select is-multiple">
				  <select multiple size="6" :disabled="allGymnasts" v-model="selectedGymnast">
				    <option v-for="gymnast in gymnasts" :key="gymnast.name" :value="gymnast.name">{{ gymnast.name }}</option>
				  </select>
				</div>
			</div>

			<div class="field">
				<label class="label">Page Format</label>
				<div class="control">
				  <label class="radio">
				    <input type="radio" value="Single 100mm x 165mm" v-model="pageFormat">
				    Single 100mm x 165mm
				  </label>
				  <label class="radio">
				    <input type="radio" value="Multiple A4" disabled v-model="pageFormat" title="Coming soon, use Adobe Acrobat's multi layout to print for now.">
				    Multiple A4
				  </label>
				</div>
			</div>

    	<div class="field">
			  <p class="control">
			    <a class="button is-primary" @click="generate" :class="button">
			      Generate
			    </a>
			  </p>
			</div>
    </div>
  </section>
</template>

<script>
import jsPDF from 'jspdf'
import {db} from '@/firebase'

export default {
  name: 'Create',
  components: {

  },
  data() {
    return {
    	isGenerating: false,
    	allGymnasts: true,
    	pageFormat: 'Single 100mm x 165mm',
    	levelsUrl: 'conditioning-levels',
    	gymnastsUrl: 'gymnasts',
    	levels: [],
    	gymnasts: [],
      pdfcount: 0,
      selectedGymnast: [],
      selectedConditioning: 'max-strength'
    }
  },

  firebase: {
    gymnasts: {
      source: db.ref('gymnasts')
    },
    levels: {
      source: db.ref('conditioning-levels')
    },
    pdfcount: {
      source: db.ref('pdfcount'),
      asObject: true
    }
  },

  methods: {
    generate () {
      if(this.allGymnasts) this.generateAll()
      else this.generateSingle()
    },

    generateSingle () {
      this.isGenerating = true
      let gymnast = this.getGymnastByName(this.selectedGymnast[0])
      let pdfName = 'conditioning-' + gymnast.name + '-' + Date.now().toString()
      var pdf = this.createPdf('Single 100mm x 165mm') // only option for now
      this.addPage(pdf, gymnast)
      this.updateCount(1)
      pdf.save(pdfName + '.pdf')
      this.isGenerating = false
    },

    getGymnastByName (name) {
      let g
      this.gymnasts.forEach(function (gymnast) {
        if(gymnast.name == name) g = gymnast
      })
      return g
    },

  	generateAll () {
 			this.isGenerating = true

      // Set Up Document
      let pdfName = 'conditioning-' + Date.now().toString()
      var pdf = this.createPdf(this.pageFormat)

      // Calculate ammount of pages
      var pages = this.gymnasts.length
      if(this.pageFormat === "Multiple A4") pages = pages / 4

      let self = this

      // Render Each Page
      let i = 0
      this.gymnasts.forEach(function (gymnast) {
        self.addPage(pdf, gymnast)
        i++
        if (i < pages) pdf.addPage()
      })

      this.updateCount(pages)
      pdf.save(pdfName + '.pdf')
  		this.isGenerating = false
  	},

    createPdf (format) {
      var x, y, orientation
      if(format === 'Single 100mm x 165mm') {
        x = 100
        y = 165
        orientation = 'portrait'
      } else if (format === "Multiple A4") {
        x = 210
        y = 297
        orientation = 'landscape'
      }
      return new jsPDF({
        orientation: orientation,
        units: 'mm',
        format: [x,y]
      })
    },

    addPage (pdf, gymnast) {
      // Header
      pdf.setFont("helvetica", "bold")
      pdf.setFontSize(16)
      pdf.setTextColor(0, 0, 0)
      pdf.text('Conditioning', 5, 8)
      pdf.setFontSize(10)
      pdf.text(gymnast.name, 43, 8)

      // Header Underline
      pdf.rect(5,10,90,1,'f')
      let sectionOffset = 11
      let sectionHeight = 38
      
      // Create Exercise Sections TODO: Make modular
      var sections = new Map()
      sections.set(0, 'arms')
      sections.set(1, 'legs')
      sections.set(2, 'stomach')
      sections.set(3, 'back')

      let self = this

      this.levels.forEach(function (level) {
        self.addSection(pdf, level, gymnast[level['.key']], sectionHeight, sectionOffset) 
        sectionOffset += 38
      })
    },

    addSection (pdf, levelData, gymnastLevel, sectionHeight, sectionOffset) {
      // Section Side Heading
      pdf.setFillColor(229, 229, 229)
      pdf.rect(5, sectionOffset, 5, sectionHeight, 'f')
      pdf.setFontSize(10)
      pdf.setFontType('bold')
      pdf.text(9, sectionOffset + (sectionHeight - 4), levelData['.key'].toUpperCase() + ' Level ' + gymnastLevel, null, 90) // Section Title

      let exercises = new Map()
      let descriptions = new Map()

      Object.keys(levelData).forEach(function(key) {
        if(key != '.key') {
          let progression = levelData[key][gymnastLevel - 1]
          exercises.set(progression.exercise, progression.quantity)
          descriptions.set(progression.exercise, progression.description)
        }
      })
      
      let exerciseHeight = sectionHeight / exercises.size
      let yOffset = sectionOffset + (exerciseHeight * 0.666)
      
      // draw exercises
      exercises.forEach(function(quantity, exercise) {
        if(exercise != undefined) {
          // Draw exercise quantity
          pdf.setFont('helvetica', 'normal')
          pdf.setFontSize(10)
          pdf.setTextColor(0, 0, 0)
          pdf.text(75, yOffset, quantity)

          // Draw description, otherwise just draw exercise title
          if(descriptions.get(exercise) != null) {
            pdf.setFontSize(10)
            pdf.text(12, yOffset, exercise)
            pdf.setFontSize(8)
            pdf.setTextColor(100, 100, 100)
            pdf.text(45, yOffset, descriptions.get(exercise))
            pdf.setTextColor(0, 0, 0)
          } else {
            pdf.text(12, yOffset, exercise)
          }
          yOffset += exerciseHeight
        }
      }) 

      // Line at bottom
      pdf.setFillColor(0,0,0)
      pdf.rect(5, sectionOffset + sectionHeight - 1, 90, 1, 'f')
    },

    updateCount (amount) {
      var count = this.pdfcount['.value'] + amount
      this.$firebaseRefs.pdfcount.set(count)
    }
  },
  computed: {
  	button () {
  		if(this.isGenerating) {
  			return 'is-loading'
  		} else {
  			return ''
  		}
  	}
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Create.vue